'use client';

import { getEnvVar } from '@vimond/utils/env';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useCallback, useContext, useEffect } from 'react';
import { AuthenticationContext } from '../provider';

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  if (!context)
    throw new Error(
      'useClientAuthentication must be used within an AuthenticationProvider',
    );

  // Add an effect to check if user is logged in and redirect if needed
  useEffect(() => {
    if (context.isLoggedIn && context.app === 'web') {
      const isVippsRedirectPage =
        window.location.pathname.includes('/vipps-redirect');

      if (isVippsRedirectPage) {
        // Add a slight delay to ensure state is properly updated
        const redirectTimer = setTimeout(() => {
          window.location.href = '/profiles/whoiswatching';
        }, 500);

        return () => clearTimeout(redirectTimer);
      }
    }
    return;
  }, [context.isLoggedIn, context.app]);

  const signInWithVipps = useCallback(async () => {
    try {
      const organization_id = getEnvVar('NEXT_PUBLIC_ORGANIZATION_ID');
      const tenant_id = getEnvVar('NEXT_PUBLIC_TENANT_ID');
      if (!organization_id || !tenant_id) {
        throw new Error(
          'Missing organization_id or tenant_id in environment variables',
        );
      }
      const defaultBaseUrl = `https://${getEnvVar('NEXT_PUBLIC_TENANT')}.default-payment-provider.${getEnvVar('NEXT_PUBLIC_ENVIRONMENT')}.vmnd.tv`;

      const response = await fetch(
        `${defaultBaseUrl}/api/v1/provider/vipps/login/parameters/${organization_id}/${tenant_id}`,
      );
      if (!response.ok) {
        throw new Error('Failed to fetch Vipps parameters');
      }
      const data = await response.json();

      await signInWithRedirect({
        provider: {
          custom: 'vipps',
        },
        customState: JSON.stringify({
          data,
        }),
      });

      return null;
    } catch (err) {
      console.error('Error during Vipps sign in:', err);
      return { isSignedIn: false, error: err };
    }
  }, []);

  return {
    ...context,
    signInWithVipps,
  };
};
